import React from 'react';

import { Flex, Td } from '@chakra-ui/react';
import emotionStyled from '@emotion/styled';
import styled from 'styled-components';

import { TextBodyMedium } from 'uiToolkitV1/Typography';

const Container = styled(Flex)`
  padding-left: ${(props) => (props.$isSubManagerRow ? '53px' : '7.5px')};
`;

const LineMakerContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
`;

const VerticalLine = emotionStyled.div`
height: ${(props) => (props.$isLast ? '60%' : '100%')};
border-left: 1px solid ${(props) => props.theme.colors.text.g3};
position: absolute;
top: 0;
left: ${({ $isSubManagerRow }) => ($isSubManagerRow ? '68px' : '23.5px')};
`;

const LShapeDiv = emotionStyled.div`
  flex: 0 0 auto;
  height: 0px;
  margin-left: 0px;
  width: 28px;
  border-left: 1px solid${(props) => props.theme.colors.text.g3};
  border-bottom: 1px solid ${(props) => props.theme.colors.text.g3};
`;

const PrecedingDownLn = emotionStyled.div`
  position: absolute;
  width: 1px;
  top: 0;
  bottom: 0;
  background:  ${(props) => props.theme.colors.text.g3};
  left: 27px;
`;

const LineMaker = ({ isSubManagerRow = false, isLast = false, isLastSubManagerRow = false }) => (
  <LineMakerContainer>
    <LShapeDiv />
    <VerticalLine $isLast={isLast} $isSubManagerRow={isSubManagerRow} />
    {isSubManagerRow && !isLastSubManagerRow ? <PrecedingDownLn /> : null}
  </LineMakerContainer>
);

export const SubCompetencyRow = ({ name, isLast = false, isSubManagerRow, isLastSubManagerRow = false }) => (
  <Td
    sx={{
      position: 'relative',
      padding: '16px',
      border: 'none !important',
    }}
  >
    <Container alignItems="baseline" $isSubManagerRow={isSubManagerRow}>
      <LineMaker isSubManagerRow={isSubManagerRow} isLast={isLast} isLastSubManagerRow={isLastSubManagerRow} />
      <TextBodyMedium>{name}</TextBodyMedium>
    </Container>
  </Td>
);

const SubCompetencyList = ({ subCompetencies, isSubManagerRow = false, isLastSubManagerRow = false }) => (
  <div>
    {Array.isArray(subCompetencies)
      ? subCompetencies.map(({ name, subCompetencyId }, index) => (
          <SubCompetencyRow
            name={name}
            key={subCompetencyId}
            isLast={index === subCompetencies.length - 1}
            isSubManagerRow={isSubManagerRow}
            isLastSubManagerRow={isLastSubManagerRow}
          />
        ))
      : null}
  </div>
);

export default SubCompetencyList;
